import type { CdnQuota } from '../types/cdn';

export type CdnQuotaState = 'ok' | 'warning' | 'exhausted';

/**
 * Состояние квоты для цвета бара и подписи.
 * warn_percent = 0 трактуем как «без предупреждения», иначе оно горело бы всегда.
 */
export function cdnQuotaState(q: CdnQuota): CdnQuotaState {
  if (q.exhausted) return 'exhausted';
  if (q.warnPercent > 0 && q.percentUsed >= q.warnPercent) return 'warning';
  return 'ok';
}

/** Ширина прогресс-бара: used / total; при исчерпании — всегда полный. */
export function cdnBarPercent(q: CdnQuota): number {
  if (q.exhausted) return 100;
  if (q.totalBytes <= 0) return 0;
  return Math.min(100, Math.max(0, (q.usedBytes / q.totalBytes) * 100));
}
